/* Update main product image. */

var $thumbImages = $('#ProductThumbs').find('a.product-single__thumbnail');
var $productImage =  $('#ProductPhotoImg');
var $productImageGallery = $('.gallery__item');

var switchImage = function (src, imgObject, el) {
 
  // Make sure element is a jquery object
   var $el = $(el);
  $el.attr('src', src);
  $el.attr('data-image-id', imgObject.id);

  
    // Update new image src to grande
    var zoomSrc = src.replace('_medium.','_1024x1024.').replace('_large.','_1024x1024.').replace('_grande.','_1024x1024.');
    $el.attr('data-zoom', zoomSrc);
  
};


jQuery(function() {
  if ( $("#ProductPhoto").length ) {
    
    

    $('#ProductPhoto').addClass('image-zoom').zoom({
      url: $productImage.attr('data-zoom')
    });

    
  }
  
  
  $thumbImages.on('click', function(evt) {
    evt.preventDefault();
      var newImg = $(this).attr('href');
      var newImageId = $(this).attr('data-image-id');

      switchImage(newImg, { id: newImageId }, $productImage);
    
      return false;
  });
  
  // cart note
  $('.cart__note-add').click(function() {
    $('.cart__note').show();
    $(this).hide();
  });  
  
});

  